const ContactInfo = () => {
  const contactDetails = [
    {
      icon: 'ri-phone-line',
      title: 'Telefoon',
      content: '0460 94 02 22',
      link: 'tel:0460940222'
    },
    {
      icon: 'ri-mail-line',
      title: 'Email',
      content: 'ngp.renovatieprojecten@gmail.com',
      link: 'mailto:ngp.renovatieprojecten@gmail.com'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Adres',
      content: 'Adelaarstraat 55 B301, Merksem 2170',
      link: null
    }
  ];

  const socialLinks = [
    { icon: 'ri-instagram-line', url: 'https://instagram.com', label: 'Instagram' },
    { icon: 'ri-facebook-fill', url: 'https://facebook.com', label: 'Facebook' },
    { icon: 'ri-linkedin-fill', url: 'https://linkedin.com', label: 'LinkedIn' },
    { icon: 'ri-whatsapp-line', url: 'https://wa.me/0460940222', label: 'WhatsApp' }
  ];

  return (
    <div className="lg:pl-8">
      <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'serif' }}>
        Contactgegevens
      </h2>
      
      <div className="space-y-6 mb-12">
        {contactDetails.map((detail, index) => (
          <div key={index} className="flex items-start gap-4">
            <div className="w-12 h-12 bg-gray-900 rounded-lg flex items-center justify-center flex-shrink-0">
              <i className={`${detail.icon} text-xl text-white`}></i>
            </div>
            <div>
              <h3 className="text-sm font-medium text-gray-600 mb-1">
                {detail.title}
              </h3>
              {detail.link ? (
                <a
                  href={detail.link}
                  className="text-lg text-gray-900 hover:text-gray-700 transition-colors cursor-pointer"
                >
                  {detail.content}
                </a>
              ) : (
                <p className="text-lg text-gray-900">
                  {detail.content}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="mb-12">
        <h3 className="text-xl font-bold text-gray-900 mb-4">
          Volg Ons
        </h3>
        <div className="flex items-center gap-3">
          {socialLinks.map((social) => (
            <a
              key={social.label}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 rounded-full bg-gray-900 text-white flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer"
              aria-label={social.label}
            >
              <i className={`${social.icon} text-xl`}></i>
            </a>
          ))}
        </div>
      </div>

      <div className="bg-gray-50 rounded-2xl p-8">
        <h3 className="text-xl font-bold text-gray-900 mb-3">
          Openingstijden
        </h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Maandag - Vrijdag</span>
            <span className="text-gray-900 font-medium">08:00 - 18:00</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Zaterdag</span>
            <span className="text-gray-900 font-medium">09:00 - 15:00</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Zondag</span>
            <span className="text-gray-900 font-medium">Gesloten</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;